import { connect } from 'react-redux';
import { getActiveListingPage } from '../../reduck/selectors';
import SegmentFilters from '../Filtering/SegmentFilters';
import { changeRegularFilter } from '../../reduck/listingPagePages.reduck';

const mapStateToProps = (state) => ({
  segmentsData: getActiveListingPage(state).filtersFromSearchLabs.find(((filterObject) => filterObject.id === 'segment_id'))
    .values.map((valueObject) => {
      const mId = state.listingPage.staticData.ucmsHierarchy.segments.find(
        (segment) => segment.id === Number(valueObject.value)).marketId;
      const markets = state.listingPage.staticData.ucmsHierarchy.markets;

      return {
        ...valueObject,
        marketId: mId,
        marketName: (markets.find((market) => market.id === mId).name
        )
      };
    }
    )
});

const mapDispatchToProps = (dispatch) => ({
  onFilterClick: (segmentId, removeSegmentFilter = false) => {
    if (removeSegmentFilter) {
      dispatch(changeRegularFilter('segment_id', undefined));
    } else {
      dispatch(changeRegularFilter('segment_id', [String(segmentId)]));
    }

  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SegmentFilters);
